import { spawn } from 'node:child_process'
import { pipeManagedDevServerStream } from './pipe-managed-dev-server-stream.js'

export function startManagedDevServer(
  cwd: string,
  devCmd: string,
  adminLoginUrl: string,
  adminCredentials?: {
    email?: string
    password?: string
  }
): Promise<void> {
  return new Promise((resolve, reject) => {
    const [bin, ...args] = devCmd.split(' ')
    const child = spawn(bin, args, {
      cwd,
      stdio: ['inherit', 'pipe', 'pipe']
    })

    const state = {
      suppressStartup: true,
      readyLogged: false,
      adminLoginUrl,
      adminEmail: adminCredentials?.email,
      adminPassword: adminCredentials?.password
    }

    const forwardSignal = (signal: NodeJS.Signals) => {
      if (!child.killed) {
        child.kill(signal)
      }
    }

    const cleanup = () => {
      process.off('SIGINT', forwardSignal)
      process.off('SIGTERM', forwardSignal)
      process.off('SIGHUP', forwardSignal)
    }

    process.on('SIGINT', forwardSignal)
    process.on('SIGTERM', forwardSignal)
    process.on('SIGHUP', forwardSignal)

    pipeManagedDevServerStream(child.stdout, process.stdout, state)
    pipeManagedDevServerStream(child.stderr, process.stderr, state)

    child.on('close', (code, signal) => {
      cleanup()

      if (signal) {
        process.kill(process.pid, signal)
        return
      }

      if (typeof code === 'number' && code !== 0) {
        process.exitCode = code
      }

      resolve()
    })

    child.on('error', (err) => {
      cleanup()
      reject(err)
    })
  })
}
